export default __webpack_public_path__ + "static/media/Group_12.5d6d8084.png";